import { render } from "./TableMinus.vue?vue&type=template&id=08e808be"
import script from "./TableMinus.vue?vue&type=script&lang=js"
export * from "./TableMinus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableMinus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08e808be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08e808be', __exports__)) {
    api.reload('08e808be', __exports__)
  }
  
  module.hot.accept("./TableMinus.vue?vue&type=template&id=08e808be", () => {
    api.rerender('08e808be', render)
  })

}


export default __exports__